export const timeOffPaths = {
  INDEX: '/',
  DAILY: '/daily',
  WEEKLY: '/weekly',
  MOTHLY: '/monthly',
}
